import React, {useState} from "react";
import FileUpload, { FileUploadState } from "../dashboard/VCApplication/FileUpload";
import Button from "../form-components/input/Button";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const UploadTranscription = () => {
    const token = sessionStorage.getItem('token')
    const [fileUpload, setFileUpload] = useState<FileUploadState[]>([
        { file: null, name: '', description: '', ext: ''}
      ]);
    const [ isLoading, setIsLoading ] = useState(false)
    const { id } = useParams<{ id: string }>();
    const transcriptionId = id;
    const fileUploads: { file: string, name: string, description: string }[] = [];
    const navigate = useNavigate();



    const getUploadUrl = async (contentType: string) => {
        const response = await fetch(
          "https://backend-kyw8.onrender.com/transcriptions/upload-url",
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ contentType, transcriptionId }),
          }
        );
    
        const data = await response.json();
    
        if (!response.ok) {
            throw new Error(data.error ?? "An error occurred");
        }
        console.log(data);
    
        return data;
    };
    
    const uploadToS3 = async (URL: string, file: Blob, contentType: string) => {
        const response = await fetch(URL, {
            method: "PUT",
            headers: {
                "Content-Type": contentType,
            },
            body: file,
        });

        if (!response.ok) {
            throw new Error("An error occurred while uploading the file(s)");
        }
        console.log("File uploaded successfully");
    };

    const uploadsDocument = async (fileUploads) => {
        const response = await fetch(
            `https://backend-kyw8.onrender.com/transcriptions`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(fileUploads),
            }
        );

        if (!response.ok) {
            const data = response.json();
            console.log(data)
            throw new Error("An error occured while uploading the file(s)");
        }
	};

    const handleSubmit = async () => {
        setIsLoading(true);

        try {
            await Promise.all(
                fileUpload.map(async (file) => {
                    if (file.file) {
                        const data = await getUploadUrl(file.ext);
                        const { uploadURL, fileURL } = data;

                        const blob = new Blob([file.file], { type: file.ext });

                        fileUploads.push({
                            file: fileURL,
                            name: file.name,
                            description: file.description,
                        });
                        console.log(fileUploads);
                        await uploadToS3(uploadURL, blob, file.ext);

                        await uploadsDocument({fileURL, transcriptionId});
                    }
                })
            );
            setIsLoading(false);

            toast.success("Transcription was successfully uploaded", {
                position: "top-center",
            });
            navigate(`/dashboard`);
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An unexpected error occurred. Please try again later.", {
                position: "bottom-right",
            });
            setIsLoading(false);
        }
    }

    return (
        <div>
            <label htmlFor="" className="form-subheader">Upload Transcription Documents</label>
            <FileUpload fileUploads={fileUpload} setFileUploads={setFileUpload} />
            <p className="text-l ">Upload Document with .docx format only</p>
            <Button
                buttonText="Submit"
                onClick={handleSubmit}
                isLoading={isLoading}
                disabled={isLoading}
            />
         </div>    
        )
}
export default UploadTranscription